// extracted by mini-css-extract-plugin
module.exports = {"desktopHeader":"desktopHeader_desktopHeader__N6dwI"};